module.exports = __webpack_public_path__ + "static/media/qr_acm.708378a0.svg";